//External
import React,{useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getBlogDetail } from 'store/actions/blog';
import ReactHtmlParser from "react-html-parser";

/*******************
@Purpose : Used forprivacy modal
@Parameter : { }
@Author : INIC
******************/
function PrivacyModal() {
  const dispatch = useDispatch()

/*******************
@Purpose : React Hook Used for dispatch blog detail
@Parameter : { showHandler, hideHandler, body, modalTitle }
@Author : INIC
******************/
  useEffect(() => {
    dispatch(getBlogDetail("privacy-policy"));
  }, []);
  const privacydata = useSelector((state) => state.blog.blogMetaData);

 /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="onboarding-content-box">
        {ReactHtmlParser(
          privacydata?.page_body?.replace(/\\n/g, "").replace(/\\r/g, "")
        )}
      </div>
    </>
  );
}

export default PrivacyModal;
